export const catalogStateKey = 'catalog';
export const productStateKey = 'products';
export const couponsStateKey = 'coupons';
export const promoCodesStateKey = 'promocodes';
export const skuStateKey = 'skus';
